import React from 'react'

export default function ContentWrapper (props) {
  return (
    <div className='flex'>
      <div className='min-h-screen flex-col flex-grow overflow-x-auto p-6 sm:px-12 sm:py-8'>
        {props.children}
      </div>
    </div>
  )
}
